import { render } from "./component_bt_contact.vue?vue&type=template&id=43d7a6e4&scoped=true"
import script from "./component_bt_contact.vue?vue&type=script&lang=js"
export * from "./component_bt_contact.vue?vue&type=script&lang=js"

import "./component_bt_contact.vue?vue&type=style&index=0&id=43d7a6e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43d7a6e4"]])

export default __exports__